define("ember-useragent/helpers/user-agent", ["exports", "@ember/component/helper", "@ember/service", "@ember/object"], function (_exports, _helper, _service, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = _helper.default.extend({
    userAgent: (0, _service.inject)(),
    compute(_ref) {
      let [prop] = _ref;
      return (0, _object.get)(this, `userAgent.${prop}`);
    }
  });
});